export const PHOTOGRAPHERS_FETCH_REQUEST = 'photographers-fetch-request';
export const PHOTOGRAPHERS_FETCH_SUCCESS = 'photographers-fetch-success';
export const PHOTOGRAPHERS_FETCH_FAILURE = 'photographers-fetch-failure';
export const PHOTOGRAPHERS_EQ_FETCH_REQUEST = 'photographers-eq-fetch-request';
export const PHOTOGRAPHERS_EQ_FETCH_SUCCESS = 'photographers-eq-fetch-success';
export const PHOTOGRAPHERS_EQ_FETCH_FAILURE = 'photographers-eq-fetch-failure';